/* ════════════════════════════════════════════════════════════════════════════
   PlayShop - Modale « crée ton compte » (VISITEURS)

   Expose `window.psGuestSignup(source)` : ouvre le pitch d'inscription.
   `source` = d'où vient le clic (ex. 'collection-badge', 'pokedex-burger') →
   remonte dans le tracking pour savoir CE QUI fait s'inscrire les gens.

   POURQUOI UN FICHIER À PART (17/07) : le pitch vivait dans
   `playshop-tcg-collection-mode.js`, qui n'est PAS chargé sur le Pokédex
   (le commentaire de ce fichier prétendait le contraire - vérifié, c'est faux).
   Résultat : 1025 étoiles muettes sur /pages/pokedex. Plutôt que de dupliquer
   le pitch (= 2 endroits à maintenir, garantie de divergence), il vit ici et se
   charge globalement. Un seul endroit à changer le jour où le pitch bouge.

   ⚠️ Les 4 arguments et le libellé du bouton DOIVENT rester identiques au bloc
   d'accueil (`sections/playshop-dashboard.liquid`, .ps-dashboard-guest) :
   une seule promesse sur tout le site.

   ⚠️ TRACKING : l'event s'appelle `tool_*` À DESSEIN. L'edge fn `track` a une
   liste blanche (ALLOWED) et jette SILENCIEUSEMENT tout type inconnu en
   répondant `{ok:true, ingested:0}`. Seul le préfixe `tool_` passe sans
   configuration. Ne PAS renommer en `signup_prompt` : l'event disparaîtrait
   sans le moindre message d'erreur.
   ════════════════════════════════════════════════════════════════════════════ */
(function () {
  let modal = null;

  function build() {
    const st = document.createElement('style');
    st.textContent = `
      .ps-gsm { position: fixed; inset: 0; z-index: 9999; display: grid; place-items: center; padding: 18px;
        background: rgba(6,8,16,.78); backdrop-filter: blur(6px); }
      .ps-gsm[hidden] { display: none; }
      .ps-gsm__box { position: relative; isolation: isolate; overflow: hidden; width: min(520px, 100%);
        border-radius: 22px; padding: clamp(26px,4vw,38px) clamp(20px,3.5vw,32px); text-align: center;
        background: radial-gradient(125% 130% at 50% -18%, #181d40 0%, #0c1020 52%, #080a12 100%);
        border: 1px solid rgba(91,123,255,.45);
        box-shadow: inset 0 1px 0 rgba(255,255,255,.05), 0 40px 90px -40px rgba(26,34,221,.9); }
      .ps-gsm__bg { position: absolute; inset: 0; z-index: 0; pointer-events: none;
        background-image: radial-gradient(58% 80% at 50% -12%, rgba(91,123,255,.32), transparent 60%),
          linear-gradient(rgba(125,145,255,.06) 1px, transparent 1px),
          linear-gradient(90deg, rgba(125,145,255,.06) 1px, transparent 1px);
        background-size: cover, 44px 44px, 44px 44px;
        -webkit-mask: radial-gradient(112% 100% at 50% 0%, #000 55%, transparent 100%);
                mask: radial-gradient(112% 100% at 50% 0%, #000 55%, transparent 100%); }
      .ps-gsm__in { position: relative; z-index: 2; }
      .ps-gsm__x { position: absolute; top: 10px; right: 12px; z-index: 5; width: 32px; height: 32px;
        border: 0; border-radius: 50%; cursor: pointer; font-size: 20px; line-height: 1;
        background: rgba(255,255,255,.07); color: #aab2d6; }
      .ps-gsm__x:hover { background: rgba(255,255,255,.14); color: #fff; }
      /* line-height 1.16 + padding-bottom : sans ça, background-clip:text coupe les jambages (g/y/p/j) */
      .ps-gsm__t { margin: 0 0 18px; font-weight: 900; font-size: clamp(1.3rem,4vw,1.7rem);
        line-height: 1.16; padding-bottom: .08em; letter-spacing: -.02em;
        background: linear-gradient(180deg,#fff,#c5ccff); -webkit-background-clip: text; background-clip: text;
        color: transparent; filter: drop-shadow(0 2px 22px rgba(91,123,255,.35)); }
      .ps-gsm__l { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 9px;
        list-style: none; margin: 0 0 20px; padding: 0; }
      .ps-gsm__l li { padding: 11px 8px; border-radius: 12px; font-size: .82rem; font-weight: 800; color: #eef1ff;
        border: 1px solid rgba(255,255,255,.10);
        background: linear-gradient(180deg, rgba(255,255,255,.055), rgba(255,255,255,.015)); }
      .ps-gsm__cta { display: block; padding: 14px 26px; border-radius: 999px; text-decoration: none;
        font-weight: 800; font-size: .95rem; color: #fff !important;
        background: linear-gradient(135deg,#1A22DD,#4357FF); box-shadow: 0 14px 34px -12px rgba(67,87,255,.85); }
      .ps-gsm__lo { display: inline-block; margin-top: 12px; font-size: .85rem; font-weight: 700;
        color: #8b9bff; text-decoration: none; border-bottom: 1px solid rgba(139,155,255,.35); }
    `;
    document.head.appendChild(st);

    const m = document.createElement('div');
    m.className = 'ps-gsm';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Créer un compte PlayShop');
    // 🔁 SOURCE DU PITCH = snippets/playshop-guest-perks.liquid. Cette modale est en JS pur (elle
    //    se construit au clic) ⇒ un snippet Liquid NE PEUT PAS y être injecté : c'est la seule
    //    copie du pitch qui vit hors du snippet, par contrainte technique. Les 4 arguments + le
    //    libellé du bouton ci-dessous DOIVENT rester identiques au snippet. Si tu changes le pitch
    //    (ex. -5% → -10%), change-le AUX DEUX endroits : ici ET dans le snippet.
    m.innerHTML =
      '<div class="ps-gsm__box">' +
        '<span class="ps-gsm__bg" aria-hidden="true"></span>' +
        '<button class="ps-gsm__x" type="button" aria-label="Fermer">&times;</button>' +
        '<div class="ps-gsm__in">' +
          '<p class="ps-gsm__t">Suis ta collection gratuitement</p>' +
          '<ul class="ps-gsm__l">' +
            '<li>Code Promo -5%</li><li>Eco-Play GRATUIT</li>' +
            '<li>100 Points OFFERTS</li><li>Suivi de Collection</li>' +
          '</ul>' +
          '<a class="ps-gsm__cta" href="/account/register">Créer mon compte - 100% GRATUIT</a>' +
          '<a class="ps-gsm__lo" href="/account/login">J\'ai déjà un compte</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);

    const close = () => { m.hidden = true; document.body.style.overflow = ''; };
    m.querySelector('.ps-gsm__x').addEventListener('click', close);
    m.addEventListener('click', (e) => { if (e.target === m) close(); }); // clic sur le fond
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !m.hidden) close(); });
    return m;
  }

  window.psGuestSignup = function (source) {
    try { window.psTrack && window.psTrack('tool_collection_signup_prompt', { source: source || 'inconnu', page: location.pathname }); } catch (_) {}
    if (!modal) modal = build();
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  /* ─── Filet global : TOUS les boutons « mode collection » du thème ────────────────────
     Ce fichier n'est chargé QUE pour un visiteur (`{% unless customer %}` dans theme.liquid),
     donc cet écouteur ne peut JAMAIS gêner un client connecté.

     Les 5 portes recensées dans le thème (grep large, sans préfixe supposé) :
       [data-ps-collect-badge]             → géré par playshop-tcg-collection-mode.js
       [data-ps-pokedex-fav-mode-toggle]   → géré par playshop-pokedex-favorites.js
       [data-tcgset-toggle-collection]     → étoile burger d'une page de SET      ⟵ ici
       [data-sealed-toggle-collection]     → étoile burger d'une page SCELLÉ      ⟵ ici
       [data-etb-toggle-collection]        → étoile burger d'une page ETB         ⟵ ici
     Les 3 dernières n'avaient AUCUN traitement visiteur : le clic ne faisait rien (la classe
     `--needs-auth` ne baisse que l'opacité à .65, c'est purement cosmétique), ou affichait un
     toast de 3 s. On les branche ici plutôt que de patcher 3 fichiers de plus.

     `stopImmediatePropagation` : indispensable. Un `stopPropagation` nu n'empêche PAS les
     autres écouteurs posés sur le MÊME nœud (document) de s'exécuter - le mode collection
     s'activerait quand même derrière la modale. Ce script est en <head> et donc exécuté avant
     ceux des sections : son écouteur en capture passe en premier et coupe les suivants. */
  const PORTES = '[data-tcgset-toggle-collection],[data-sealed-toggle-collection],[data-etb-toggle-collection]';
  document.addEventListener('click', function (e) {
    const el = e.target.closest && e.target.closest(PORTES);
    if (!el) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const src = el.hasAttribute('data-tcgset-toggle-collection') ? 'set-burger'
              : el.hasAttribute('data-sealed-toggle-collection') ? 'scelle-burger'
              : 'etb-burger';
    window.psGuestSignup(src);
  }, true);
})();
